import React from 'react';
import { Stars } from '@catalogo/theme-stars';
import styled from 'styled-components';
import { Nav } from '@catalogo/core-nav';

const NoReviews = ({ productId }) => (
  <>
    <WrapperNotRating>
      <Stars rating={0} size={34} />
      <RecommendTextNotRating>
        Ajude outras pessoas, <span>faça a primeira avaliação desse produto ;)</span>
      </RecommendTextNotRating>
      <div>
        <ButtonNotRating to={`/avaliacao/${productId}`}>Avaliar produto</ButtonNotRating>
      </div>
    </WrapperNotRating>
  </>
);

const WrapperNotRating = styled.div`
  background: #fff;
  padding: 0 16px;
`;

const RecommendTextNotRating = styled.div`
  font-size: 14px;
  line-height: 1.4;
  color: ${({ theme }) => theme.grey.dark};
  padding: 16px 0 28px;
  border-bottom: 1px solid ${({ theme }) => theme.grey.light};
  margin-bottom: 20px;

  span {
    display: flex;
    font-size: 16px;
    font-weight: bold;
  }
`;

const ButtonNotRating = styled(Nav)`
  border: 2px solid ${({ theme }) => theme.primaryColor};
  border-radius: 8px;
  padding: 12px 0;
  background: ${({ theme }) => theme.white};
  color: ${({ theme }) => theme.primaryColor};
  font-size: 16px;
  outline: 0;
  text-align: center;
  text-transform: ${({ theme }) => theme.titleTransform};
  margin: 20px 0 0;
  display: block;
  font-weight: ${({ theme }) => theme.btnTextWeigth};
  cursor: pointer;

  & :hover {
    color: ${({ theme }) => theme.primaryColor};
  }
`;

export default NoReviews;
